import { createSelector } from '@reduxjs/toolkit';
import { getConfig } from './config';

export default createSelector([getConfig], config =>
  config.upsellTitle ? config.upsellTitle : config.upsellDefaultTitle,
);
